(function () {
  window.cardService = {
    get() {
      return axios.get(`/api/card/get.php`);
    },
    getActive(data) {
      return axios.get('/api/card/active.php');
    },
    save(data) {
      return axios.post('/api/card/save.php', data);
    },
    getEventCards(){
      return axios.get(`/api/events/card/get.php`);
    },
    getActiveEventCards(){
      return axios.get(`/api/events/card/active.php`);
    },
    eventSave(data){
      return axios.post('/api/events/card/save.php', data);
    }
  };
})();
